module.exports = __webpack_public_path__ + "static/street-tehran-5fd76155caed5d4dadff7edd46af308b.png";